module.exports = " <div> <single-day v-for=\"day in weekdays\" :day-label=day :day-number=\"dayNumber | calcDayNumber $index\" :date=dateFor($index) :index=$index> </single-day> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/CalendarWeek.vue
// module id = 325
// module chunks = 2